import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstPd0: [],
		pd0: null,
		pda: {
			pdaseq: 0,
			pdatermina: "",
		},
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, pd0){
			state.pd0 = pd0
			if (pd0)
				state.update = true
		},
		setpda(state, pda){
			state.pda = pda
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.pd0 = null
			state.pda = {
				pdaseq: 0,
				pdatermina: "",
			}
		},
		setParamsDataTable(state, payload){
			state.lstPd0 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, pd0codigo){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/OryxPdv/Terminal/Find/${pd0codigo}`)
			.then((response) => {
				let pd0 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", pd0)

				if(store.rootState.lxd.lxd && store.rootState.lxd.lxd.lxdtef){
					store.dispatch("getPda")
				}
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		async getPda(store){
			store.state.loading = true
			await this._vm.$axios.get(`/PaymentCondition/TEFIntegrationTerminal/Find?pdacodigo=${store.state.pd0.pd0codigo}`)
			.then(response => {
				let pda = Utils.ValidateAxiosResponse(response.data);
				store.commit("setpda", pda)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.pd0.pd0codigo){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/OryxPdv/Terminal/Insert", store.state.pd0 )
			.then(async (response) => {
				store.state.pd0 = Utils.ValidateAxiosResponse(response.data);
				if(store.rootState.lxd.lxd && store.rootState.lxd.lxd.lxdtef){
					await this._vm.$axios.post("/PaymentCondition/TEFIntegrationTerminal/Insert", {pdacodigo: store.state.pd0.pd0codigo, ...store.state.pda} )
					.then(response => {
						Utils.ValidateAxiosResponse(response.data);
					})
				}
				router.push("/oryxpdv/terminais")
				store.state.pd0 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/OryxPdv/Terminal/Update", store.state.pd0 )
			.then(async (response) => {
				Utils.ValidateAxiosResponse(response.data);
				if(store.rootState.lxd.lxd && store.rootState.lxd.lxd.lxdtef){
					await this._vm.$axios.put("/PaymentCondition/TEFIntegrationTerminal/Update", store.state.pda )
					.then(response => {
						Utils.ValidateAxiosResponse(response.data);
					})
				}
				router.push("/oryxpdv/terminais")
				store.state.pd0 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			
			if(store.rootState.lxd.lxd && store.rootState.lxd.lxd.lxdtef){
				await this._vm.$axios.delete(`/PaymentCondition/TEFIntegrationTerminal/Delete?pdacodigo=${store.state.pd0.pd0codigo}`)
				.then(async (response) => {
					Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				})
			}
			await this._vm.$axios.delete(`/OryxPdv/Terminal/Delete/${store.state.pd0.pd0codigo}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/terminais")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/OryxPdv/Terminal/FindList")
			.then(response => {
				let lstPd0 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstPd0 = lstPd0
				store.state.hasNext = lstPd0.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstPd0 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/OryxPdv/Terminal/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstPd0 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}